import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, {
        dark: "",
        color: "primary",
        tile: "",
        flat: "",
        class: "mb-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            icon: "",
            dark: "",
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("欠席登録", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_form, { ref: "post_absence_form" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "py-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_menu, {
                modelValue: _ctx.isDatePicker,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isDatePicker) = $event)),
                "close-on-content-click": false,
                transition: "scale-transition",
                "min-width": "auto",
                location: "bottom"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    modelValue: _ctx.dateRangeText,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRangeText) = $event)),
                    label: "期間",
                    "prepend-icon": "mdi-calendar",
                    rules: [_ctx.rules.required],
                    variant: "outlined",
                    density: "compact",
                    readonly: ""
                  }, props, { color: "primary" }), null, 16, ["modelValue", "rules"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_date_picker, {
                        modelValue: _ctx.dates,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dates) = $event)),
                        "hide-header": "",
                        multiple: "range",
                        color: "primary",
                        locale: "ja",
                        style: {"transform":"scale(0.8)"}
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            color: "primary",
                            onClick: _ctx.cancelDatePick
                          }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createTextVNode(" キャンセル ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            color: "primary",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDatePicker = false))
                          }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode(" OK ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_select, {
                modelValue: _ctx.reason,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reason) = $event)),
                rules: [_ctx.rules.required],
                label: "理由",
                items: _ctx.choices,
                "item-title": "text",
                "item-value": "value",
                outlined: "",
                dense: "",
                color: "primary"
              }, null, 8, ["modelValue", "rules", "items"]),
              (_ctx.reason === 'infection')
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 0,
                    modelValue: _ctx.infectionReason,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.infectionReason) = $event)),
                    rules: [_ctx.infectionRules],
                    label: "詳細",
                    items: _ctx.infectionChoices,
                    "item-title": "text",
                    "item-value": "value",
                    outlined: "",
                    dense: "",
                    color: "primary"
                  }, null, 8, ["modelValue", "rules", "items"]))
                : _createCommentVNode("", true),
              (_ctx.reason === 'others')
                ? (_openBlock(), _createBlock(_component_v_textarea, {
                    key: 1,
                    modelValue: _ctx.comment,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.comment) = $event)),
                    rules: [_ctx.rules.counter500],
                    label: "コメント",
                    "auto-grow": "",
                    outlined: "",
                    dense: "",
                    color: "primary"
                  }, null, 8, ["modelValue", "rules"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.close,
                color: "error",
                text: ""
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" キャンセル ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.clickPost,
                loading: _ctx.btnLoading,
                color: "primary",
                variant: "flat"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" 送信 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}